import { render, staticRenderFns } from "./PrizesThumb.vue?vue&type=template&id=36b8a096&scoped=true"
import script from "./PrizesThumb.vue?vue&type=script&lang=js"
export * from "./PrizesThumb.vue?vue&type=script&lang=js"
import style0 from "./PrizesThumb.vue?vue&type=style&index=0&id=36b8a096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b8a096",
  null
  
)

export default component.exports